import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { ICourseStructureSubcategoryQuery } from '../interfaces/course-structure-subcategory.query.interface';

// @dynamic
export class CourseStructureSubcategory {
    id: string;
    name: string;
    type: string;
    sort: number;
    image: MaxbrainImage;
    parent: {
        id: string;
        name: string;
        type: string;
        sort: number;
    };

    constructor(query: ICourseStructureSubcategoryQuery) {
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.sort = query.sort;
            this.type = query.type;
            this.image = query.image ? new MaxbrainImage(query.image) : null;
            this.parent = query.parent
                ? {
                      id: String(query.parent.id),
                      name: query.parent.name,
                      type: query.parent.type,
                      sort: null,
                  }
                : null;
        }
    }
}
